import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {



  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  FlatList,
  Modal,
  TextInput,
  Alert,
  Dimensions,
  Image,
  ActivityIndicator,
  RefreshControl,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

// ===== API Configuration =====
const API_BASE_URL = 'https://api.jobeng.ai';

const getCompanyId = async () => {
  try {
    const userData = await AsyncStorage.getItem('currentUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user.company_id || user.companyId || null;
    }
    const companyProfile = await AsyncStorage.getItem('companyProfile');
    if (companyProfile) {
      const company = JSON.parse(companyProfile);
      return company.id || company.company_id || null;
    }
    const bid = await AsyncStorage.getItem('company_id') || await AsyncStorage.getItem('company_id');
    if (bid) return bid;
    return null;
  } catch (e) {
    console.error('Error getting company_id:', e);
    return null;
  }
};

const apiRequest = async (endpoint, options = {}) => {
  try {
    const companyId = await getCompanyId();
    // Split endpoint and query string
    const [path, queryString] = endpoint.split('?');
    // Route: auth/* goes to /api/auth/*, everything else to /api/data/{table}
    let baseUrl;
    if (path.startsWith('auth/')) {
      baseUrl = `${API_BASE_URL}/api/${path}`;
    } else {
      // Convert hyphens to underscores for DB table mapping
      const dbPath = path.replace(/-/g, '_');
      baseUrl = `${API_BASE_URL}/api/data/${dbPath}`;
    }
    const params = new URLSearchParams(queryString || '');
    if (companyId) { params.set('company_id', companyId); params.set('company_id', companyId); }
    const separator = params.toString() ? '?' : '';
    const url = `${baseUrl}${separator}${params.toString()}`;

    const token = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' };
    if (token) headers.Authorization = 'Bearer ' + token;
    const fetchOpts = { headers, ...options };
    if (options.body) fetchOpts.body = JSON.stringify(options.body);
    const response = await fetch(url, fetchOpts);

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};
// ===== End API Configuration =====


const { width, height } = Dimensions.get('window');

const TestCandidatesPipelineScreen = ({ navigation, route }) => {
  // ✅ Safe parameter extraction
  const routeParams = route?.params || {};
  const selectedCandidates = routeParams.selectedCandidates || [];
  const candidate = routeParams.candidate || null;
  const totalCandidates = routeParams.totalCandidates || 0;
  
  
  const jobId = route?.params?.jobId || route?.params?.job_id || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
const [testCandidates, setTestCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedTab, setSelectedTab] = useState('pending');
  const [showTestModal, setShowTestModal] = useState(false);
  const [showTestSuiteModal, setShowTestSuiteModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [testType, setTestType] = useState('technical');
  const [testDuration, setTestDuration] = useState(60);
  const [testInstructions, setTestInstructions] = useState('');
  const [selectedTestSuite, setSelectedTestSuite] = useState(null);
  const [availableTestSuites, setAvailableTestSuites] = useState([]);
  const [testBankStats, setTestBankStats] = useState({
    totalQuestions: 0,
    totalSuites: 0,
    activeQuestions: 0,
    categories: []
  });

  const testTypes = [
    {
      id: 'technical',
      name: 'Technical Assessment',
      icon: 'code-tags',
      color: '#3B82F6',
      description: 'Coding challenges and technical questions',
      duration: [60, 90, 120],
      defaultDuration: 90
    },
    {
      id: 'aptitude',
      name: 'Aptitude Test',
      icon: 'brain',
      color: '#10B981',
      description: 'Logical reasoning and problem solving',
      duration: [30, 45, 60],
      defaultDuration: 45
    },
    {
      id: 'personality',
      name: 'Personality Assessment',
      icon: 'account-heart',
      color: '#F59E0B',
      description: 'Cultural fit and personality traits',
      duration: [20, 30, 45],
      defaultDuration: 30
    },
    {
      id: 'behavioral',
      name: 'Behavioral Assessment',
      icon: 'account-group',
      color: '#EC4899',
      description: 'Situational and behavioral questions',
      duration: [30, 45, 60],
      defaultDuration: 45
    },
    {
      id: 'custom',
      name: 'Custom Test',
      icon: 'file-document-edit',
      color: '#8B5CF6',
      description: 'Custom assessment designed for role',
      duration: [30, 60, 90, 120],
      defaultDuration: 60
    }
  ];

  const tabs = [
    { id: 'pending', name: 'Pending Tests', icon: 'clock-outline', color: '#F59E0B' },
    { id: 'in_progress', name: 'In Progress', icon: 'play-circle-outline', color: '#3B82F6' },
    { id: 'completed', name: 'Completed', icon: 'check-circle-outline', color: '#10B981' },
    { id: 'failed', name: 'Failed', icon: 'close-circle-outline', color: '#EF4444' }
  ];

    // Company logo (same as EditSupplierScreen)
  useFocusEffect(React.useCallback(() => { loadCompanyLogo(); }, []));
  const loadCompanyLogo = async () => {
    try {
      const cachedProfile = await AsyncStorage.getItem('company_profile');
      if (cachedProfile) {
        const profile = JSON.parse(cachedProfile);
        setCompanyLogo(profile.logo || null);
        if (profile.name || profile.company_name) setCompanyName(profile.name || profile.company_name);
      }
    } catch (e) { console.warn('Logo load error:', e.message); }
  };

useEffect(() => {
    loadTestCandidates();
    loadTestBankData();
    loadAvailableTestSuites();
  }, []);

  const loadTestBankData = async () => {
    try {
      // Load test bank statistics from AsyncStorage
      // Fetch test bank data from API first
      let testBankData = null;
      try {
        const tbResponse = await apiRequest('test-bank-stats');
        if (tbResponse.success && tbResponse.data) {
          testBankData = JSON.stringify(tbResponse.data);
          await AsyncStorage.setItem('testBankData', testBankData);
        }
      } catch (apiErr) {
        testBankData = await AsyncStorage.getItem('testBankData');
      }
      if (testBankData) {
        const parsedData = JSON.parse(testBankData);
        setTestBankStats(parsedData.stats || {
          totalQuestions: 0,
          totalSuites: 0,
          activeQuestions: 0,
          categories: []
        });
      } else {
        // Generate mock test bank stats
        setTestBankStats({
          totalQuestions: 156,
          totalSuites: 12,
          activeQuestions: 142,
          categories: [
            { name: 'Technical', count: 68, percentage: 44 },
            { name: 'Aptitude', count: 34, percentage: 22 },
            { name: 'Personality', count: 28, percentage: 18 },
            { name: 'Behavioral', count: 26, percentage: 16 }
          ]
        });
      }
    } catch (error) {
      console.error('Error loading test bank data:', error);
    }
  };

  const loadAvailableTestSuites = async () => {
    try {
      // Load available test suites from AsyncStorage
      // Fetch test suites from API first
      let testSuites = null;
      try {
        const tsResponse = await apiRequest('test-suites');
        if (tsResponse.success && tsResponse.data) {
          testSuites = JSON.stringify(tsResponse.data);
          await AsyncStorage.setItem('testSuites', testSuites);
        }
      } catch (apiErr) {
        testSuites = await AsyncStorage.getItem('testSuites');
      }
      if (testSuites) {
        const parsedSuites = JSON.parse(testSuites);
        setAvailableTestSuites(parsedSuites);
      } else {
        // Generate mock test suites
        const mockSuites = [
          {
            id: 'suite_1',
            name: 'React Developer Assessment',
            description: 'Comprehensive React and JavaScript assessment',
            category: 'technical',
            difficulty: 'medium',
            duration: 90,
            totalQuestions: 15,
            passingScore: 70,
            isActive: true,
            timesUsed: 23,
            averageScore: 75,
            completionRate: 89
          },
          {
            id: 'suite_2',
            name: 'Senior Frontend Developer Test',
            description: 'Advanced frontend development skills assessment',
            category: 'technical',
            difficulty: 'hard',
            duration: 120,
            totalQuestions: 20,
            passingScore: 75,
            isActive: true,
            timesUsed: 15,
            averageScore: 68,
            completionRate: 82
          },
          {
            id: 'suite_3',
            name: 'Problem Solving & Logic',
            description: 'Analytical thinking and problem-solving skills',
            category: 'aptitude',
            difficulty: 'medium',
            duration: 45,
            totalQuestions: 12,
            passingScore: 65,
            isActive: true,
            timesUsed: 45,
            averageScore: 72,
            completionRate: 94
          },
          {
            id: 'suite_4',
            name: 'Team Collaboration Assessment',
            description: 'Behavioral and teamwork evaluation',
            category: 'behavioral',
            difficulty: 'easy',
            duration: 30,
            totalQuestions: 10,
            passingScore: 60,
            isActive: true,
            timesUsed: 38,
            averageScore: 78,
            completionRate: 96
          },
          {
            id: 'suite_5',
            name: 'Cultural Fit Evaluation',
            description: 'Personality and cultural alignment assessment',
            category: 'personality',
            difficulty: 'easy',
            duration: 25,
            totalQuestions: 8,
            passingScore: 55,
            isActive: true,
            timesUsed: 52,
            averageScore: 81,
            completionRate: 98
          }
        ];
        setAvailableTestSuites(mockSuites);
        await AsyncStorage.setItem('testSuites', JSON.stringify(mockSuites));
        try { await apiRequest('test-suites', { method: 'POST', body: { suites: mockSuites } }); } catch(e) {}
      }
    } catch (error) {
      console.error('Error loading test suites:', error);
    }
  };

  // Generate mock test candidates
  const generateTestCandidates = useCallback(() => {
    const mockCandidates = [];
    
    // If we have selected candidates from previous screen
    if (selectedCandidates.length > 0) {
      selectedCandidates.forEach((candidateId, index) => {
        const statuses = ['pending', 'in_progress', 'completed', 'failed'];
        const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
        
        mockCandidates.push({
          id: candidateId,
          name: `Candidate ${candidateId.split('_')[1] || index + 1}`,
          email: `candidate${candidateId.split('_')[1] || index + 1}@email.com`,
          position: 'Software Engineer',
          avatar: `https://ui-avatars.com/api/?name=Candidate+${candidateId.split('_')[1] || index + 1}&background=random`,
          testStatus: randomStatus,
          assignedDate: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
          testType: randomStatus !== 'pending' ? testTypes[Math.floor(Math.random() * testTypes.length)].id : null,
          testSuite: randomStatus !== 'pending' ? availableTestSuites[Math.floor(Math.random() * availableTestSuites.length)]?.name : null,
          testScore: randomStatus === 'completed' ? Math.floor(Math.random() * 40) + 60 : null,
          testDuration: randomStatus !== 'pending' ? Math.floor(Math.random() * 60) + 30 : null,
          completedDate: randomStatus === 'completed' ? new Date(Date.now() - Math.random() * 3 * 24 * 60 * 60 * 1000).toISOString() : null,
          attempts: randomStatus !== 'pending' ? Math.floor(Math.random() * 2) + 1 : 0,
          timeRemaining: randomStatus === 'in_progress' ? Math.floor(Math.random() * 3600) + 600 : null,
          progress: randomStatus === 'in_progress' ? Math.floor(Math.random() * 80) + 10 : null,
          notes: Math.random() > 0.7 ? 'Strong technical background' : '',
          priority: ['high', 'medium', 'low'][Math.floor(Math.random() * 3)]
        });
      });
    } else {
      // Generate default candidates if none provided
      for (let i = 1; i <= Math.max(totalCandidates, 15); i++) {
        const statuses = ['pending', 'in_progress', 'completed', 'failed'];
        const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
        
        mockCandidates.push({
          id: `candidate_${i}`,
          name: `Test Candidate ${i}`,
          email: `testcandidate${i}@email.com`,
          position: 'Software Engineer',
          avatar: `https://ui-avatars.com/api/?name=Test+Candidate+${i}&background=random`,
          testStatus: randomStatus,
          assignedDate: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
          testType: randomStatus !== 'pending' ? testTypes[Math.floor(Math.random() * testTypes.length)].id : null,
          testSuite: randomStatus !== 'pending' ? availableTestSuites[Math.floor(Math.random() * availableTestSuites.length)]?.name : null,
          testScore: randomStatus === 'completed' ? Math.floor(Math.random() * 40) + 60 : null,
          testDuration: randomStatus !== 'pending' ? Math.floor(Math.random() * 60) + 30 : null,
          completedDate: randomStatus === 'completed' ? new Date(Date.now() - Math.random() * 3 * 24 * 60 * 60 * 1000).toISOString() : null,
          attempts: randomStatus !== 'pending' ? Math.floor(Math.random() * 2) + 1 : 0,
          timeRemaining: randomStatus === 'in_progress' ? Math.floor(Math.random() * 3600) + 600 : null,
          progress: randomStatus === 'in_progress' ? Math.floor(Math.random() * 80) + 10 : null,
          notes: Math.random() > 0.7 ? 'Strong technical background' : '',
          priority: ['high', 'medium', 'low'][Math.floor(Math.random() * 3)]
        });
      }
    }
    
    return mockCandidates;
  }, [selectedCandidates, totalCandidates, testTypes, availableTestSuites]);

  const loadTestCandidates = async () => {
    setIsLoading(true);
    try {
      // Fetch test candidates from API first
      let savedCandidates = null;
      try {
        const tcResponse = await apiRequest('test-candidates');
        if (tcResponse.success && tcResponse.data) {
          savedCandidates = JSON.stringify(tcResponse.data);
          await AsyncStorage.setItem('testCandidates', savedCandidates);
        }
      } catch (apiErr) {
        savedCandidates = await AsyncStorage.getItem('testCandidates');
      }
      // Fallback: fetch from applications table (real candidate data)
      if (!savedCandidates) {
        try {
          const appsResponse = await apiRequest('applications');
          if (appsResponse.success && appsResponse.data && appsResponse.data.length > 0) {
            const realCandidates = appsResponse.data.map(app => ({
              id: app.id, name: app.candidate_name || 'Unknown', email: app.candidate_email || '',
              position: app.current_title || '', company: app.current_company || '',
              testStatus: ['assessment','video_interview','final_interview'].includes(app.stage) ? 'in_progress' : app.stage === 'hired' || app.stage === 'accepted' ? 'completed' : app.stage === 'rejected' ? 'failed' : 'pending',
              testScore: app.ai_score || 0, aiScore: app.ai_score || 0,
              priority: (app.ai_score || 0) >= 85 ? 'high' : (app.ai_score || 0) >= 70 ? 'medium' : 'low',
              assignedDate: app.applied_date, stage: app.stage,
            }));
            savedCandidates = JSON.stringify(realCandidates);
            await AsyncStorage.setItem('testCandidates', savedCandidates);
          }
        } catch (e2) { console.warn('Applications fallback failed:', e2.message); }
      }
      if (savedCandidates) {
        setTestCandidates(JSON.parse(savedCandidates));
      } else {
        const mockCandidates = generateTestCandidates();
        setTestCandidates(mockCandidates);
        await AsyncStorage.setItem('testCandidates', JSON.stringify(mockCandidates));
        try { await apiRequest('test-candidates', { method: 'POST', body: { candidates: mockCandidates } }); } catch(e) {}
      }
    } catch (error) {
      console.error('Error loading test candidates:', error);
      const mockCandidates = generateTestCandidates();
      setTestCandidates(mockCandidates);
    } finally {
      setIsLoading(false);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await loadTestCandidates();
    await loadTestBankData();
    await loadAvailableTestSuites();
    setRefreshing(false);
  };

  const filteredCandidates = useMemo(() => {
    return testCandidates.filter(candidate => candidate.testStatus === selectedTab);
  }, [testCandidates, selectedTab]);

  const getTabCounts = useMemo(() => {
    const counts = {};
    tabs.forEach(tab => {
      counts[tab.id] = testCandidates.filter(candidate => candidate.testStatus === tab.id).length;
    });
    return counts;
  }, [testCandidates, tabs]);

  const handleAssignTest = async (candidateId, testData) => {
    try {
      const updatedCandidates = testCandidates.map(candidate => {
        if (candidate.id === candidateId) {
          return {
            ...candidate,
            testStatus: 'pending',
            testType: testData.testType,
            testSuite: testData.testSuite,
            testDuration: testData.duration,
            assignedDate: new Date().toISOString(),
            notes: testData.instructions || candidate.notes
          };
        }
        return candidate;
      });

      setTestCandidates(updatedCandidates);
      try { await apiRequest('test-candidates', { method: 'PUT', body: { candidates: updatedCandidates } }); } catch(e) { console.warn('API save failed:', e.message); }
      await AsyncStorage.setItem('testCandidates', JSON.stringify(updatedCandidates));
      
      Alert.alert('Success', 'Test assigned successfully!');
      setShowTestModal(false);
      setShowTestSuiteModal(false);
      setSelectedCandidate(null);
    } catch (error) {
      console.error('Error assigning test:', error);
      Alert.alert('Error', 'Failed to assign test');
    }
  };

  const handleStartTest = async (candidateId) => {
    try {
      const updatedCandidates = testCandidates.map(candidate => {
        if (candidate.id === candidateId) {
          return {
            ...candidate,
            testStatus: 'in_progress',
            startedDate: new Date().toISOString(),
            timeRemaining: candidate.testDuration * 60, // Convert to seconds
            progress: 0
          };
        }
        return candidate;
      });

      setTestCandidates(updatedCandidates);
      try { await apiRequest('test-candidates', { method: 'PUT', body: { candidates: updatedCandidates } }); } catch(e) { console.warn('API save failed:', e.message); }
      await AsyncStorage.setItem('testCandidates', JSON.stringify(updatedCandidates));
      
      Alert.alert('Test Started', 'The candidate can now begin their test.');
    } catch (error) {
      console.error('Error starting test:', error);
      Alert.alert('Error', 'Failed to start test');
    }
  };

  const formatTimeRemaining = (seconds) => {
    if (!seconds) return 'N/A';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const getTestTypeInfo = (testTypeId) => {
    return testTypes.find(type => type.id === testTypeId) || testTypes[0];
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'easy': return '#10B981';
      case 'medium': return '#F59E0B';
      case 'hard': return '#EF4444';
      case 'expert': return '#8B5CF6';
      default: return '#6B7280';
    }
  };

  const renderCandidateCard = ({ item }) => {
    const testTypeInfo = getTestTypeInfo(item.testType);
    
    return (
      <TouchableOpacity style={styles.candidateCard}>
        <View style={styles.candidateHeader}>
          <Image source={{ uri: (item.avatar && item.avatar.startsWith('http')) ? item.avatar : undefined }} style={styles.candidateAvatar} />
          <View style={styles.candidateInfo}>
            <Text style={styles.candidateName}>{item.name}</Text>
            <Text style={styles.candidatePosition}>{item.position}</Text>
            <Text style={styles.candidateEmail}>{item.email}</Text>
          </View>
          <View style={styles.candidateMeta}>
            <View style={[styles.priorityBadge, { backgroundColor: item.priority === 'high' ? '#EF4444' : item.priority === 'medium' ? '#F59E0B' : '#10B981' }]}>
              <Text style={styles.priorityText}>{String(item.priority ?? '').toUpperCase()}</Text>
            </View>
          </View>
        </View>

        {item.testType && (
          <View style={styles.testInfo}>
            <View style={styles.testTypeContainer}>
              <MaterialCommunityIcons name={testTypeInfo.icon} size={20} color={testTypeInfo.color} />
              <Text style={styles.testTypeName}>{testTypeInfo.name}</Text>
            </View>
            {item.testSuite && (
              <Text style={styles.testSuite}>Suite: {item.testSuite}</Text>
            )}
          </View>
        )}

        <View style={styles.candidateStats}>
          {item.testStatus === 'pending' && (
            <>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="calendar" size={16} color="#6B7280" />
                <Text style={styles.statLabel}>Assigned</Text>
                <Text style={styles.statValue}>{formatDate(item.assignedDate)}</Text>
              </View>
              <TouchableOpacity
                style={styles.actionButton}
                onPress={() => handleStartTest(item.id)}
              >
                <MaterialCommunityIcons name="play" size={16} color="#FFFFFF" />
                <Text style={styles.actionButtonText}>Start Test</Text>
              </TouchableOpacity>
            </>
          )}

          {item.testStatus === 'in_progress' && (
            <>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="clock" size={16} color="#F59E0B" />
                <Text style={styles.statLabel}>Time Left</Text>
                <Text style={styles.statValue}>{formatTimeRemaining(item.timeRemaining)}</Text>
              </View>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="chart-line" size={16} color="#3B82F6" />
                <Text style={styles.statLabel}>Progress</Text>
                <Text style={styles.statValue}>{item.progress}%</Text>
              </View>
            </>
          )}

          {item.testStatus === 'completed' && (
            <>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="star" size={16} color="#10B981" />
                <Text style={styles.statLabel}>Score</Text>
                <Text style={[styles.statValue, { color: item.testScore >= 70 ? '#10B981' : '#EF4444' }]}>
                  {item.testScore}%
                </Text>
              </View>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="calendar-check" size={16} color="#6B7280" />
                <Text style={styles.statLabel}>Completed</Text>
                <Text style={styles.statValue}>{formatDate(item.completedDate)}</Text>
              </View>
            </>
          )}

          {item.testStatus === 'failed' && (
            <>
              <View style={styles.statItem}>
                <MaterialCommunityIcons name="close-circle" size={16} color="#EF4444" />
                <Text style={styles.statLabel}>Attempts</Text>
                <Text style={styles.statValue}>{item.attempts}</Text>
              </View>
              <TouchableOpacity
                style={[styles.actionButton, styles.retryButton]}
                onPress={() => {
                  setSelectedCandidate(item);
                  setShowTestModal(true);
                }}
              >
                <MaterialCommunityIcons name="refresh" size={16} color="#FFFFFF" />
                <Text style={styles.actionButtonText}>Retry</Text>
              </TouchableOpacity>
            </>
          )}
        </View>

        {item.notes && (
          <View style={styles.notesContainer}>
            <Text style={styles.notesText}>{item.notes}</Text>
          </View>
        )}

        {item.testStatus === 'pending' && !item.testType && (
          <TouchableOpacity
            style={styles.assignTestButton}
            onPress={() => {
              setSelectedCandidate(item);
              setShowTestSuiteModal(true);
            }}
          >
            <MaterialCommunityIcons name="plus" size={16} color="#8B5CF6" />
            <Text style={styles.assignTestButtonText}>Assign Test</Text>
          </TouchableOpacity>
        )}
      </TouchableOpacity>
    );
  };

  const renderTestSuiteModal = () => (
    <Modal visible={showTestSuiteModal} transparent animationType="slide">
      <View style={styles.modalOverlay}>
        <View style={styles.testSuiteModal}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalTitle}>Select Test Suite</Text>
            <TouchableOpacity onPress={() => setShowTestSuiteModal(false)}>
              <Ionicons name="close" size={24} color="#333" />
            </TouchableOpacity>
          </View>
          
          <ScrollView style={styles.modalContent}>
            <Text style={styles.sectionTitle}>Available Test Suites</Text>
            
            {availableTestSuites.filter(suite => suite.isActive).map((suite) => (
              <TouchableOpacity
                key={suite.id}
                style={[
                  styles.testSuiteOption,
                  selectedTestSuite?.id === suite.id && styles.selectedTestSuiteOption
                ]}
                onPress={() => setSelectedTestSuite(suite)}
              >
                <View style={styles.testSuiteHeader}>
                  <Text style={styles.testSuiteName}>{suite.name}</Text>
                  <View style={[styles.difficultyBadge, { backgroundColor: getDifficultyColor(suite.difficulty) }]}>
                    <Text style={styles.difficultyText}>{String(suite.difficulty ?? '').toUpperCase()}</Text>
                  </View>
                </View>
                
                <Text style={styles.testSuiteDescription}>{suite.description}</Text>
                
                <View style={styles.testSuiteStats}>
                  <View style={styles.testSuiteStat}>
                    <MaterialCommunityIcons name="clock" size={14} color="#6B7280" />
                    <Text style={styles.testSuiteStatText}>{suite.duration} min</Text>
                  </View>
                  <View style={styles.testSuiteStat}>
                    <MaterialCommunityIcons name="help-circle" size={14} color="#6B7280" />
                    <Text style={styles.testSuiteStatText}>{suite.totalQuestions} questions</Text>
                  </View>
                  <View style={styles.testSuiteStat}>
                    <MaterialCommunityIcons name="target" size={14} color="#6B7280" />
                    <Text style={styles.testSuiteStatText}>{suite.passingScore}% pass</Text>
                  </View>
                </View>
                
                <View style={styles.testSuitePerformance}>
                  <Text style={styles.performanceText}>
                    Used {suite.timesUsed} times • Avg Score: {suite.averageScore}% • Completion: {suite.completionRate}%
                  </Text>
                </View>
              </TouchableOpacity>
            ))}
            
            <TouchableOpacity
              style={styles.createCustomTestButton}
              onPress={() => {
                setShowTestSuiteModal(false);
                setShowTestModal(true);
              }}
            >
              <MaterialCommunityIcons name="plus-circle" size={20} color="#8B5CF6" />
              <Text style={styles.createCustomTestButtonText}>Create Custom Test</Text>
            </TouchableOpacity>
          </ScrollView>
          
          <View style={styles.modalFooter}>
            <TouchableOpacity
              style={styles.cancelButton}
              onPress={() => setShowTestSuiteModal(false)}
            >
              <Text style={styles.cancelButtonText}>Cancel</Text>
            </TouchableOpacity>
            
            <TouchableOpacity
              style={[styles.assignButton, !selectedTestSuite && styles.disabledButton]}
              disabled={!selectedTestSuite}
              onPress={() => {
                if (selectedTestSuite && selectedCandidate) {
                  handleAssignTest(selectedCandidate.id, {
                    testType: selectedTestSuite.category,
                    testSuite: selectedTestSuite.name,
                    duration: selectedTestSuite.duration,
                    instructions: `Complete the ${selectedTestSuite.name} assessment. You have ${selectedTestSuite.duration} minutes to complete ${selectedTestSuite.totalQuestions} questions. Passing score is ${selectedTestSuite.passingScore}%.`
                  });
                }
              }}
            >
              <Text style={styles.assignButtonText}>Assign Test Suite</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );

  const renderCustomTestModal = () => (
    <Modal visible={showTestModal} transparent animationType="slide">
      <View style={styles.modalOverlay}>
        <View style={styles.testModal}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalTitle}>Create Custom Test</Text>
            <TouchableOpacity onPress={() => setShowTestModal(false)}>
              <Ionicons name="close" size={24} color="#333" />
            </TouchableOpacity>
          </View>
          
          <ScrollView style={styles.modalContent}>
            <Text style={styles.sectionTitle}>Test Type</Text>
            <View style={styles.testTypeGrid}>
              {testTypes.map((type) => (
                <TouchableOpacity
                  key={type.id}
                  style={[
                    styles.testTypeCard,
                    testType === type.id && styles.selectedTestTypeCard
                  ]}
                  onPress={() => {
                    setTestType(type.id);
                    setTestDuration(type.defaultDuration);
                  }}
                >
                  <MaterialCommunityIcons name={type.icon} size={24} color={type.color} />
                  <Text style={styles.testTypeCardTitle}>{type.name}</Text>
                  <Text style={styles.testTypeCardDescription}>{type.description}</Text>
                </TouchableOpacity>
              ))}
            </View>
            
            <Text style={styles.sectionTitle}>Duration</Text>
            <View style={styles.durationOptions}>
              {getTestTypeInfo(testType).duration.map((duration) => (
                <TouchableOpacity
                  key={duration}
                  style={[
                    styles.durationOption,
                    testDuration === duration && styles.selectedDurationOption
                  ]}
                  onPress={() => setTestDuration(duration)}
                >
                  <Text style={[
                    styles.durationOptionText,
                    testDuration === duration && styles.selectedDurationOptionText
                  ]}>
                    {duration} min
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
            
            <Text style={styles.sectionTitle}>Instructions</Text>
            <TextInput
              style={styles.instructionsInput}
              value={testInstructions}
              onChangeText={setTestInstructions}
              placeholder="Enter test instructions for the candidate..."
              multiline
              numberOfLines={4}
              textAlignVertical="top"
            />
          </ScrollView>
          
          <View style={styles.modalFooter}>
            <TouchableOpacity
              style={styles.cancelButton}
              onPress={() => setShowTestModal(false)}
            >
              <Text style={styles.cancelButtonText}>Cancel</Text>
            </TouchableOpacity>
            
            <TouchableOpacity
              style={styles.assignButton}
              onPress={() => {
                if (selectedCandidate) {
                  handleAssignTest(selectedCandidate.id, {
                    testType: testType,
                    testSuite: `Custom ${getTestTypeInfo(testType).name}`,
                    duration: testDuration,
                    instructions: testInstructions
                  });
                }
              }}
            >
              <Text style={styles.assignButtonText}>Assign Test</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );

  if (isLoading) {
    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#8B5CF6" />
          <Text style={styles.loadingText}>Loading test pipeline...</Text>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#8B5CF6" />
      
      {/* Header */}
      <LinearGradient colors={['#8B5CF6', '#7C3AED']} style={styles.header}>
        <View style={styles.headerContent}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <MaterialCommunityIcons name="arrow-left" size={24} color="#FFFFFF" />
          </TouchableOpacity>
          
          <View style={styles.headerInfo}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              {companyLogo ? (
                <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 8 }} />
              ) : (
                <MaterialCommunityIcons name="office-building" size={20} color="#fff" style={{ marginRight: 8 }} />
              )}
              <Text style={styles.headerTitle}>Testing Pipeline</Text>
            </View>
            {jobTitle ? <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11 }}>{jobTitle}</Text> : null}
            <Text style={styles.headerSubtitle}>
              {testCandidates.length} Candidates • {filteredCandidates.length} {selectedTab}
            </Text>
          </View>
          
          <TouchableOpacity 
            style={styles.statsButton}
            onPress={() => navigation.navigate('TestsBankManagementScreen', { jobId, jobTitle, companyLogo, companyName })}
          >
            <MaterialCommunityIcons name="database" size={24} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      </LinearGradient>
      {/* Cross Navigation */}
      <View style={{ backgroundColor: '#FFF', borderBottomWidth: 1, borderBottomColor: '#E5E7EB' }}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingHorizontal: 12, paddingVertical: 8 }}>
          {jobTitle ? <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#0e4e9615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.goBack()}>
            <MaterialCommunityIcons name="briefcase" size={14} color="#0e4e96" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#0e4e96', marginLeft: 4 }}>Job Details</Text>
          </TouchableOpacity> : null}
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#8B5CF615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestApplicantsScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="clipboard-check" size={14} color="#8B5CF6" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#8B5CF6', marginLeft: 4 }}>Test Applicants</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#10B98115', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestResultsScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="chart-box" size={14} color="#10B981" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#10B981', marginLeft: 4 }}>Test Results</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#F59E0B15', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestsBankManagementScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="database-cog" size={14} color="#F59E0B" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#F59E0B', marginLeft: 4 }}>Tests Bank</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>


      {/* Test Bank Stats */}
      <View style={styles.testBankStats}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.statsContent}>
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="help-circle" size={20} color="#3B82F6" />
            <Text style={styles.statNumber}>{testBankStats.totalQuestions}</Text>
            <Text style={styles.statLabel}>Questions</Text>
          </View>
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="folder-multiple" size={20} color="#10B981" />
            <Text style={styles.statNumber}>{testBankStats.totalSuites}</Text>
            <Text style={styles.statLabel}>Test Suites</Text>
          </View>
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="check-circle" size={20} color="#F59E0B" />
            <Text style={styles.statNumber}>{testBankStats.activeQuestions}</Text>
            <Text style={styles.statLabel}>Active</Text>
          </View>
          <TouchableOpacity 
            style={[styles.statCard, styles.manageButton]}
            onPress={() => navigation.navigate('TestsBankManagementScreen', { jobId, jobTitle, companyLogo, companyName })}
          >
            <MaterialCommunityIcons name="cog" size={20} color="#8B5CF6" />
            <Text style={[styles.statLabel, { color: '#8B5CF6', fontWeight: '600' }]}>Manage</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>

      {/* Status Tabs */}
      <View style={styles.tabsContainer}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.tabsContent}>
          {tabs.map((tab) => (
            <TouchableOpacity
              key={tab.id}
              style={[
                styles.tab,
                selectedTab === tab.id && styles.activeTab,
                { borderBottomColor: tab.color }
              ]}
              onPress={() => setSelectedTab(tab.id)}
            >
              <MaterialCommunityIcons
                name={tab.icon}
                size={18}
                color={selectedTab === tab.id ? tab.color : '#6B7280'}
              />
              <Text style={[
                styles.tabText,
                selectedTab === tab.id && { color: tab.color }
              ]}>
                {tab.name}
              </Text>
              <View style={[
                styles.tabBadge,
                selectedTab === tab.id && { backgroundColor: tab.color }
              ]}>
                <Text style={[
                  styles.tabBadgeText,
                  selectedTab === tab.id && styles.activeTabBadgeText
                ]}>
                  {getTabCounts[tab.id] || 0}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Candidates List */}
      <FlatList
        data={filteredCandidates}
        keyExtractor={(item) => item.id}
        renderItem={renderCandidateCard}
        style={styles.candidatesList}
        contentContainerStyle={styles.candidatesListContent}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        ListEmptyComponent={() => (
          <View style={styles.emptyContainer}>
            <MaterialCommunityIcons name="clipboard-list" size={64} color="#D1D5DB" />
            <Text style={styles.emptyTitle}>No {selectedTab} tests</Text>
            <Text style={styles.emptySubtitle}>
              {selectedTab === 'pending' 
                ? 'Assign tests to candidates to get started' 
                : `No candidates have ${selectedTab} tests`}
            </Text>
            {selectedTab === 'pending' && (
              <TouchableOpacity
                style={styles.emptyActionButton}
                onPress={() => navigation.navigate('TestsBankManagementScreen', { jobId, jobTitle, companyLogo, companyName })}
              >
                <MaterialCommunityIcons name="plus" size={20} color="#FFFFFF" />
                <Text style={styles.emptyActionButtonText}>Manage Test Bank</Text>
              </TouchableOpacity>
            )}
          </View>
        )}
      />

      {/* Modals */}
      {renderTestSuiteModal()}
      {renderCustomTestModal()}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#4A90E2',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#6B7280',
  },
  header: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerInfo: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  headerSubtitle: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.8)',
    marginTop: 4,
  },
  statsButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  testBankStats: {
    backgroundColor: '#FFFFFF',
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  statsContent: {
    paddingHorizontal: 20,
  },
  statCard: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    marginRight: 12,
    minWidth: 80,
  },
  manageButton: {
    backgroundColor: '#F3E8FF',
  },
  statNumber: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },
  tabsContainer: {
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tabsContent: {
    paddingHorizontal: 20,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 12,
    marginRight: 8,
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  activeTab: {
    borderBottomWidth: 2,
  },
  tabText: {
    marginLeft: 6,
    fontSize: 14,
    fontWeight: '500',
    color: '#6B7280',
  },
  tabBadge: {
    marginLeft: 6,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
    backgroundColor: '#E5E7EB',
  },
  tabBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#6B7280',
  },
  activeTabBadgeText: {
    color: '#FFFFFF',
  },
  candidatesList: {
    flex: 1,
  },
  candidatesListContent: {
    padding: 20,
  },
  candidateCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  candidateHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  candidateAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  candidateInfo: {
    flex: 1,
  },
  candidateName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 2,
  },
  candidatePosition: {
    fontSize: 14,
    color: '#374151',
    marginBottom: 2,
  },
  candidateEmail: {
    fontSize: 12,
    color: '#6B7280',
  },
  candidateMeta: {
    alignItems: 'flex-end',
  },
  priorityBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  priorityText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  testInfo: {
    marginBottom: 12,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
  },
  testTypeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  testTypeName: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#374151',
  },
  testSuite: {
    fontSize: 12,
    color: '#6B7280',
    fontStyle: 'italic',
  },
  candidateStats: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  statItem: {
    alignItems: 'center',
    flex: 1,
  },
  statLabel: {
    fontSize: 10,
    color: '#6B7280',
    marginTop: 2,
  },
  statValue: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 2,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#3B82F6',
    borderRadius: 12,
  },
  retryButton: {
    backgroundColor: '#F59E0B',
  },
  actionButtonText: {
    marginLeft: 4,
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  notesContainer: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
  },
  notesText: {
    fontSize: 12,
    color: '#6B7280',
    fontStyle: 'italic',
  },
  assignTestButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    backgroundColor: '#F3E8FF',
    borderRadius: 12,
    marginTop: 8,
  },
  assignTestButtonText: {
    marginLeft: 4,
    fontSize: 14,
    fontWeight: '600',
    color: '#8B5CF6',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
    marginBottom: 8,
  },
  emptySubtitle: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
    paddingHorizontal: 40,
    marginBottom: 20,
  },
  emptyActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: '#8B5CF6',
    borderRadius: 12,
  },
  emptyActionButtonText: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  testSuiteModal: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: width * 0.95,
    maxHeight: height * 0.8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  testModal: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: width * 0.9,
    maxHeight: height * 0.7,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
  },
  modalContent: {
    padding: 20,
    maxHeight: 400,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 12,
  },
  testSuiteOption: {
    padding: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    marginBottom: 12,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  selectedTestSuiteOption: {
    borderColor: '#8B5CF6',
    backgroundColor: '#F3E8FF',
  },
  testSuiteHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  testSuiteName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    flex: 1,
  },
  difficultyBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  difficultyText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  testSuiteDescription: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 12,
  },
  testSuiteStats: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  testSuiteStat: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  testSuiteStatText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  testSuitePerformance: {
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
  },
  performanceText: {
    fontSize: 11,
    color: '#9CA3AF',
  },
  createCustomTestButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 16,
    backgroundColor: '#F3E8FF',
    borderRadius: 12,
    marginTop: 8,
  },
  createCustomTestButtonText: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#8B5CF6',
  },
  testTypeGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  testTypeCard: {
    width: (width - 80) / 2,
    padding: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    marginRight: 12,
    marginBottom: 12,
    borderWidth: 2,
    borderColor: 'transparent',
    alignItems: 'center',
  },
  selectedTestTypeCard: {
    borderColor: '#8B5CF6',
    backgroundColor: '#F3E8FF',
  },
  testTypeCardTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    marginTop: 8,
    textAlign: 'center',
  },
  testTypeCardDescription: {
    fontSize: 11,
    color: '#6B7280',
    marginTop: 4,
    textAlign: 'center',
  },
  durationOptions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  durationOption: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: '#F3F4F6',
    borderRadius: 20,
    marginRight: 8,
    marginBottom: 8,
  },
  selectedDurationOption: {
    backgroundColor: '#8B5CF6',
  },
  durationOptionText: {
    fontSize: 14,
    color: '#6B7280',
    fontWeight: '500',
  },
  selectedDurationOptionText: {
    color: '#FFFFFF',
  },
  instructionsInput: {
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 12,
    padding: 12,
    fontSize: 14,
    color: '#1F2937',
    backgroundColor: '#FFFFFF',
    minHeight: 100,
  },
  modalFooter: {
    flexDirection: 'row',
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
  },
  cancelButton: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    backgroundColor: '#F3F4F6',
    borderRadius: 12,
    marginRight: 8,
  },
  cancelButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#6B7280',
  },
  assignButton: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    backgroundColor: '#8B5CF6',
    borderRadius: 12,
    marginLeft: 8,
  },
  disabledButton: {
    backgroundColor: '#D1D5DB',
  },
  assignButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});

export default TestCandidatesPipelineScreen;